/** @require: var domfocus = require('@webhare-system/dom/focus');
*/
const legacybase = require('@webhare-system/internal/legacybase');
import { dispatchCustomEvent } from "dompack";

function getIframeFocusableNodes(body, currentnode, recurseframes)
{
  //ADDME force body into list?
  var subnodes = [];
  try
  {
    const body = (currentnode.contentDocument || currentnode.contentWindow.document).body;
    if (body.isContentEditable)
      return subnodes;

    subnodes = getFocusableComponents(body, recurseframes);
  }
  catch (e)
  {
    console.log("failed to descend into iframe",e);
  }

  return subnodes;
}

// Get node.currentStyle (split off becuase of unoptimizable try-catch)
function GetCurrentStyle(currentnode)
{
  var currentstyle;
  try { currentstyle = currentnode.currentStyle; } catch (e) { }
  return currentstyle;
}

function getFocusableComponents(startnode, recurseframes)
{
  var focusable=[];
  for(var currentnode=startnode.firstChild;currentnode;currentnode=currentnode.nextSibling) //can't use element.getChildren, startnode may be document
  {
    if(!legacybase.isHTMLElement(currentnode))
    {
      //if(currentnode.getStyle) console.log("getFocusableComponents skipping",currentnode, $(currentnode).getStyle("display"), currentnode.getStyle("visibility"))
      continue;
    }

    // Get current style (avoid mootools due to cross-frame issues)
    var currentstyle;
    if (window.getComputedStyle)
      currentstyle = getComputedStyle(currentnode);
    else
      currentstyle = GetCurrentStyle(currentnode);

    if (!currentstyle || currentstyle.display == "none" || currentstyle.visibility == "hidden")
    {
      //if(currentnode.getStyle) console.log("getFocusableComponents skipping",currentnode, $(currentnode).getStyle("display"), currentnode.getStyle("visibility"))
      continue;
    }

    if(recurseframes && currentnode.nodeName == "IFRAME") //might contain more things to focus
    {
      const subnodes = getIframeFocusableNodes(currentnode, currentnode, recurseframes);
      if(subnodes.length)
        focusable=focusable.concat(subnodes);
    }
    else if(isFocusableComponent(currentnode))
    {
      focusable.push(currentnode);
    }

    if (currentnode.isContentEditable)
      continue;

    const subnodes = getFocusableComponents(currentnode, recurseframes);
    if(subnodes.length)
      focusable = focusable.concat(subnodes);
  }
  return focusable;
}

function getToplevelWindow()
{
  let toplevelwindow = window;
  while(toplevelwindow.frameElement)
    toplevelwindow = toplevelwindow.parent;
  return toplevelwindow;
}


function getFocusableElement(element) //get the focusable element for an input field. understands replacement
{
  if(element.retrieve)
  {
    const replacedby = element.retrieve("wh-ui-replacedby");
    if(replacedby)
      return replacedby;
  }
  return element;
}

function isFocusableComponent(node) //returns if a -visible- node is focusable (this function does not check for visibility itself)
{
  try
  {
    if(node.nodeType != 1)
      return false;
    if(node.contentEditable === "true")
      return true;
    // http://dev.w3.org/html5/spec-preview/editing.html#focusable
    if(node.tabIndex == -1) //explicitly disabled
      return false;
  //console.log(node);//console.log(node.getAttribute('tabIndex'));
    return (parseInt(node.getAttribute('tabIndex')) >= 0) //we cannot read the property tabIndex directly, as IE <= 8 will return '0' even if the tabIndex is missing
           || (["A","LINK"].contains(node.nodeName) && node.href)
           || (["BUTTON","SELECT","TEXTAREA","COMMAND"].contains(node.nodeName) && !node.disabled)
           || (node.nodeName=="INPUT" && node.type != "hidden" && !node.disabled);
  }
  catch(e)
  {
    return false; //the code above may fail eg on IE11 if it's a Flash object that'ss still loading
  }
}

/// Returns whether the element or a subnode is focused
function hasFocus(element)
{
  if(!element.ownerDocument)
    return false;
  if(element && element.retrieve)
  {
    var replacedby = element.retrieve("wh-ui-replacedby");
    if(replacedby)
      element = replacedby;
  }
  return element == legacybase.getActiveElement(element.ownerDocument);
}

/// Returns whether an element contains (or its replacement) the current focused element
function containsFocus(element)
{
  if(!element.ownerDocument)
    return false;
  if(element && element.retrieve)
  {
    var replacedby = element.retrieve("wh-ui-replacedby");
    if(replacedby)
      element = replacedby;
  }

  // Test if focused element is element itself or a subnode (contains also return true on when the nodes equal each other)
  return element.contains(legacybase.getActiveElement(element.ownerDocument));
}

function focus(node)
{
  if(!node.focus)
  {
    console.log("Does not look like a focusable element", node);
    throw new Error("Does not look like a focusable element");
  }

  if (!dispatchCustomEvent(window, "wh:domfocus-prefocus", { detail: { target: node }, bubbles: false, cancelable: true }))
    return false;

  try
  {
    node.focus();
  }
  catch(e)
  {
    //ignore errors, IE likes to throw
  }
}

function getAllFocusableComponents()
{
  return getFocusableComponents(getToplevelWindow().document, true);
}
/** Find the currently focused element
    @param limitwin If set, only return compontents in the specified document (prevents editable iframes from returning subframes) */
function getCurrentlyFocusedElement(limitdoc)
{
  try
  {
    var focused = legacybase.getActiveElement(getToplevelWindow().document);
    while(true)
    {
      if (focused.tagName == "IFRAME" && (!limitdoc || focused.ownerDocument != limitdoc))
        focused = legacybase.getActiveElement(focused.contentDocument);
      else
        break;
    }
    if(focused && limitdoc && focused.ownerDocument != limitdoc)
      return null;
    return focused;
  }
  catch(e)
  {
    return null;
  }
}

module.exports = { getFocusableElement: getFocusableElement
                 , isFocusableComponent: isFocusableComponent
                 , containsFocus: containsFocus
                 , hasFocus: hasFocus
                 , focus: focus
                 , getCurrentlyFocusedElement:getCurrentlyFocusedElement
                 , getAllFocusableComponents:getAllFocusableComponents
                 , getFocusableComponents: getFocusableComponents
                 };



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/system/nodejs/dom/focus.es